<template>
  <Combobox v-model="selected" :disabled="disabled">
    <div class="relative w-full">
      <div
        class="flex w-full px-3 py-2 border rounded-lg bg-white"
        :class="disabled
          ? 'border-argus-border opacity-50'
          : 'border-argus-border hover:border-argus-emerald-400'"
      >
        <ComboboxInput
          class="w-full text-sm text-argus-forest-800 outline-none bg-transparent border-0 px-0 py-0 focus:ring-0 focus:border-0"
          :displayValue="(opt) => opt ? opt.label : ''"
          :placeholder="placeholder"
          @change="query = $event.target.value"
        />
        <ComboboxButton class="flex items-center">
          <ChevronDownIcon class="w-5 h-5 text-argus-forest-600" />
        </ComboboxButton>
      </div>
      <transition
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ComboboxOptions
          class="absolute w-full py-2 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10"
        >
          <div v-if="filtered.length === 0" class="px-3 py-2 text-sm text-argus-forest-600">
            No matches.
          </div>
          <ComboboxOption
            v-for="item in filtered"
            :key="item.value"
            v-slot="{ active }"
            :value="item"
            as="template"
          >
            <li
              class="px-3 py-2 cursor-pointer"
              :class="active ? 'bg-argus-emerald-500 text-white' : 'text-argus-forest-800'"
            >
              {{ item.label }}
            </li>
          </ComboboxOption>
        </ComboboxOptions>
      </transition>
    </div>
  </Combobox>
</template>
<script>
import {
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOptions,
  ComboboxOption,
} from '@headlessui/vue'
import { ChevronDownIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    Combobox,
    ComboboxInput,
    ComboboxButton,
    ComboboxOptions,
    ComboboxOption,
    ChevronDownIcon,
  },
  props: {
    options: { type: Array, required: true },
    initial: { type: Object, default: null },
    placeholder: { type: String, default: 'Search…' },
    disabled: { type: Boolean, default: false },
  },
  emits: ['select'],
  data() {
    return {
      selected: this.initial,
      query: '',
    }
  },
  computed: {
    filtered() {
      if (!this.query) return this.options
      const q = this.query.toLowerCase()
      return this.options.filter((o) => (o.label || '').toLowerCase().includes(q))
    },
  },
  watch: {
    initial: {
      handler(val) {
        this.selected = val
      },
      immediate: true,
    },
    selected(val, oldVal) {
      if (!oldVal && this.initial && val && val.value === this.initial.value) return
      this.$emit('select', val)
    },
  },
}
</script>